import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { ToastMessageProps } from '@standardsdigital/ui-components/Toast';
import type { RootState } from '../store';

const initialState: ToastMessageProps[] = [];

function generateId() {
  return `toast-${Math.random().toString(36).slice(2, 11)}`;
}

const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
    showToast(state, action: PayloadAction<Omit<ToastMessageProps, 'id'>>) {
      state.push({
        ...action.payload,
        id: generateId(),
      });
    },
    showSuccessToast(state, action: PayloadAction<string>) {
      state.push({
        id: generateId(),
        message: action.payload,
        variant: 'success',
      });
    },
    showErrorToast(state, action: PayloadAction<string>) {
      state.push({
        id: generateId(),
        message: action.payload,
        variant: 'danger',
      });
    },
    showWarningToast(state, action: PayloadAction<string>) {
      state.push({
        id: generateId(),
        message: action.payload,
        variant: 'warning',
      });
    },
    showInfoToast(state, action: PayloadAction<string>) {
      state.push({
        id: generateId(),
        message: action.payload,
        variant: 'neutral',
      });
    },
    clearToastMessages() {
      return initialState;
    },
  },
});

export const {
  showToast,
  showSuccessToast,
  showErrorToast,
  showWarningToast,
  showInfoToast,
  clearToastMessages,
} = messageSlice.actions;

export const selectToastMessages = (state: RootState) => state.message;

export default messageSlice.reducer;
